import React, { useState } from "react";
import { SearchDropDownWithBase } from "../../../../components";
import queryString from "query-string";
import values from "../../../../values";
import Context from "../../../../context";
import { IOnSearchUser } from "../../../../types/common.interface";
import { useTranslation } from "react-i18next";

const SearchSuperAgent = () => {
  // ============================ Value Validations =========================
  const { requestSuperAgent, setRequestSuperAgent } = React.useContext(
    Context.MunicipulityScreen
  );
  const [defaultSearch, setDefaultSearch] = useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );

  const { t } = useTranslation();
  const baseSearch = values.dropdownBaseSearch.MUNICIPALITY_BASE_SEARCH.map(
    (item) => {
      return { ...item, title: t(item?.title) };
    }
  );

  // =============================== Navigation =============================

  function onSearch(event: IOnSearchUser) {
    setRequestSuperAgent({
      ...requestSuperAgent,
      search: {
        base: event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  // ============================== JSX Contents ============================

  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: IOnSearchUser) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch}
      placeHolder={t("search")}
    />
  );
};

export default SearchSuperAgent;
